export var EnumIframeAuthActions;
(function (EnumIframeAuthActions) {
  EnumIframeAuthActions["CHECK_AUTH"] = "CHECK_AUTH";
})(EnumIframeAuthActions || (EnumIframeAuthActions = {}));